// @ts-nocheck
/* eslint-disable react/prop-types */
import * as React from 'react';
import { createContext , useState , useContext} from "react";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { SnackbarKey, SnackbarProvider, closeSnackbar, enqueueSnackbar } from 'notistack'
import Button from '@mui/material/Button';
import './Footer.css';
import {InfoPrewContext} from '../Default';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';


function Copyright() {
  return (
    <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1,fontSize: '15px !important' }}>
      <FormattedMessage id = "langID00011"/>&nbsp;
      <Link href="https://www.alsi.co.jp/" target="_blank"><FormattedMessage id = "langID00012"/>&nbsp;</Link>
      <FormattedMessage id = "langID00013"/>
    </Typography>
  );
}


export default function Footer() {
  const [open, setOpen] = React.useState(true);
  const {noticeTitle,setNoticeTitle,noticeMsg,setNoticeMsg,noticeMsgOpen,setNoticeMsgOpen,noticeDate,setNoticeDate} = useContext(InfoPrewContext);
  const arg1=[];
  const handleClose = () => {
    setNoticeMsgOpen(false);
  };
  
    const resData = async (): Promise<Post[]> => {
    const url = process.env.REACT_APP_NOTICE_API_URL;
    try{
      let bodyData;
      bodyData= {
      category: "4",
    };

  const headers = new Headers({
            "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
            'Access-Control-Allow-Credentials': 'true'
        });
  return fetch(url , {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(bodyData)
    })
    .then((response) => {
      if (!response.ok ){
        throw new Error('status is not 200');
      }
      return response.json();
    })
    .then(jsondata => {
      return jsondata;
    })
    .catch(error => {
    });;
    }catch{
    }
};


  React.useEffect(() => {
      (async function () {
      const data = await resData();
      for(var i in data){
        let value = localStorage.getItem("notice");
        if(value !== null){
          const session = JSON.parse(value);
          var date_difference = Date.now() - session.time;
          if(date_difference > 1000 * 60 * 60 *24){
            localStorage.removeItem('notice')
          }else{
            if(session.idList.includes(data[i]._id)){
              continue;
            }
          }
        }
        enqueueSnackbar(data[i].title, {
        persist: true,
        key:i,
        variant: data[i].type,
        preventDuplicate:true,
        action:  (key) => (
          <div>
          <Button variant="text" sx={{ color:'white'}} onClick={() => { 
              setNoticeTitle(data[key].title);
              setNoticeMsg(data[key].content);
              setNoticeDate(data[key].start_date);
              setNoticeMsgOpen(true);
          }}>
          詳細
          </Button>
          <IconButton aria-label='Close' color='inherit' onClick={() => {
          var idList = [];
          let value = localStorage.getItem("notice");
          if(value !== null){
            const session = JSON.parse(value);
            if(session.idList.includes(data[key]._id)){
              idList=session.idList;
            }else{
              idList=session.idList;
              idList.push(data[key]._id);
            }
          }else{
            idList.push(data[key]._id);
          }
          const param1 = { // 渡したいパラメータをJSON形式で書く
            idList:idList,
            time:Date.now()
          };
          localStorage.setItem("notice", JSON.stringify(param1));
          closeSnackbar(key);
            
          }}>
          {/* ボタンのアイコンを設定　https://mui.com/material-ui/material-icons/*/}
          <CloseIcon />
          </IconButton>
          </div>
        ),
      
      
        className:'notice-bar-',
        classes:'notice-bar-'
      })
        
      }
    })();
    

   }, []);
  
  return (
    <Container maxWidth="xl"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 4, sm: 8 },
        py: { xs: 8, sm: 10 },
        textAlign: { sm: 'center', md: 'left' },
      }}
    >

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          pt: { xs: 4, sm: 8 },
          width: '100%',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <div style={{ marginTop: '-48px',fontSize: '15px' }}>
          <Copyright />
          <Link href="https://www.alsi.co.jp/privacy/" target="_blank"><FormattedMessage id = "langID00062"/>&nbsp;</Link>　
          <Link href="/Threat_Intelligence_Platform.pdf" target="_blank"><FormattedMessage id = "langID00064"/>&nbsp;</Link>

        </div>
      </Box>
     
      <SnackbarProvider  maxSnack={4} />
      <Dialog
        maxWidth="md"
        open={noticeMsgOpen}
        onClose={handleClose}
        //PaperComponent={handleClose}
        fullWidth="true"
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          <Stack my={1} direction="row" justifyContent="end" spacing={1}>
          <IconButton aria-label="delete" onClick={handleClose}  sx={{zIndex: 10001}} >
            <CloseIcon />
          </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Box   sx={{ justifyContent: 'flex-end',top:'0px',position:'relative' }}>
          <h3 class="columnTitle">{noticeTitle}</h3><br/>
          <Typography variant="h6" sx={{textAlign: 'right', justifyContent: 'flex-end',top:'40px',position:'absolute',right: '0px' }}>
               {noticeDate.substring(0, noticeDate.indexOf("T"))}<br/>               
            </Typography>
            </Box>
              <div style={{ whiteSpace:"pre-wrap" }} className="App">
                {noticeMsg}
              </div>
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
